import FormBtn from "app/Components/CommanComponents/FormBtn";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import ViewBasicDetailsComponent from "./Component/ViewBasicDetailsComponent";
import toastr from "toastr";
// import MedicalForm from "./Component/MedicalForm";

// import MedicalHistoryList from "./Component/MedicalHistoryList";

import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import {
  MEDICAL_STATUS,
  MEDICAL_STATUS_VIEW,
} from "app/_pages/_healthSafetyEnvironment/Medical/Constant";
import {
  employeeFormLabel,
  employeeMedicalCategoryObj,
  employeeMedicalEligibilityObj,
  EMPLOYEE_MEDICAL_CATEGORY,
  WidgetBox,
} from "../Employee/Constant";
import MedicalForm from "../Employee/Component/MedicalForm";
import MedicalHistoryList from "../Employee/Component/MedicalHistoryList";
import {
  getContractorPersonById,
  updateContractorPersonMedical,
} from "app/_services/UserManagement/ContractorPersonService";
import { ContractorPersonActions } from "./Constant";

function ContractorPersonMedicalForm() {
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  const { id } = useParams();
  const [siteList, setSiteList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [initialForm, setInitialForm] = useState({});
  const [isActive, setIsActive] = useState(false);
  const history = useHistory();
  const getFormData = useCallback(async () => {
    getContractorPersonById(id).then((response) => {
      if (!response?.status) {
        history.push("/user-management/contractor-person");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      const row = response.data;

      setForm({
        ...row,
        siteType: row?.ehsSite?.siteType || "",
      });

      setInitialForm({
        ...row,
        siteType: row?.ehsSite?.siteType || "",
      });

      setHistoryList(
        (row?.employeeMedicalHistory || []).map((d, i) => ({
          ...d,
          sid: i + 1,
          siteName: d?.ehsSiteForHistory?.name,
          createdAtView: d.createdAt ? DDMMYYYYFormat(d.createdAt) : "",
          smeCategory: d?.medicalAssigneeData?.smeCategory,
          specialMedicalExamCategoryName:
            EMPLOYEE_MEDICAL_CATEGORY[d?.specialMedicalExamCategory],
          specialMedicalExamEligibility: d?.isMedicalAssined ? "YES" : "NO",
          medicalDueDateView: d?.medicalAssigneeData?.dueDate
            ? DDMMYYYYFormat(d?.medicalAssigneeData?.dueDate)
            : "",
          medicalStatusView:
            d?.medicalAssigneeData?.deleted === 1
              ? "Deleted"
              : MEDICAL_STATUS_VIEW[d?.medicalAssigneeData?.medicalStatus],
          editFlag: d?.deleted !== 1 && !d?.endDate ? true : false,
        }))
      );
    });
  }, [id]);

  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1&filter[activeStatus]=active");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  }, []);

  const effectiveDateFlag = useMemo(
    () =>
      form?.specialMedicalExamCategory &&
      initialForm?.specialMedicalExamCategory !== form?.specialMedicalExamCategory,
    [form?.specialMedicalExamCategory, initialForm?.specialMedicalExamCategory]
  );

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};

    if (+initialForm?.trainingDesignation === +form?.trainingDesignation)
      extraToChange.effectiveDate = "";

    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      let errorObj = {};

      if (!form.specialMedicalExamEligibility)
        errorObj["specialMedicalExamEligibility"] =
          employeeFormLabel["specialMedicalExamEligibility"] + " is Required.";

      if (!form.specialMedicalExamCategory)
        errorObj["specialMedicalExamCategory"] =
          employeeFormLabel["specialMedicalExamCategory"] + " is Required.";

      if (effectiveDateFlag && !form?.effectiveDate) {
        errorObj["effectiveDate"] = employeeFormLabel["effectiveDate"] + " is Required.";
      }

      setError(errorObj);

      if (Object.values(errorObj).filter((d) => d !== "").length) return;

      let formObj = JSON.parse(JSON.stringify(form));

      if (effectiveDateFlag) formObj.effectiveDate = form?.effectiveDate;

      let response = await updateContractorPersonMedical(id, {
        employee: formObj,
      });
      if (!response?.status) return toastr.error(response?.message);

      toastr.success(response.message || "Success.");
      // push(`/user-management/employee`);
      getFormData();
    },
    [effectiveDateFlag, form, getFormData, id]
  );

  useEffect(() => {
    getAllSiteList();
  }, [getAllSiteList]);

  useEffect(() => {
    if (!id) return;

    getFormData();
  }, [getFormData, id]);

  return (
    <Card className="overflow-inherit">
      <Card.Body>
        <Card.Title className="simple-card-title justify-content-between">
          <h3 class="text-capitalize mb-1">Change medical SME</h3>
          <ContractorPersonActions id={id} form={form} />
        </Card.Title>
        <WidgetBox form={form} />
        <ViewBasicDetailsComponent form={form} />
        <h4 className="highlighted-text">Current Medical details</h4>
        <Row>
          {/* <Col md={4}>
            <h5>Is Last PME Date Available</h5>
            <p>{initialForm.isPmeDate ? "Yes" : "No"}</p>
          </Col>
          <Col md={4}>
            <h5>{employeeFormLabel["pmeDate"]}</h5>
            <p>{initialForm?.pmeDate ? DDMMYYYYFormat(initialForm?.pmeDate) : ""}</p>
          </Col> */}
          <Col md={4}>
            <h5>{employeeFormLabel["specialMedicalExamEligibility"]}</h5>
            <p>
              {employeeMedicalEligibilityObj[initialForm?.specialMedicalExamEligibility]}
            </p>
          </Col>
          <Col md={4}>
            <h5>{employeeFormLabel["specialMedicalExamCategory"]}</h5>
            <p>{employeeMedicalCategoryObj[initialForm?.specialMedicalExamCategory]}</p>
          </Col>
        </Row>

        {isActive ? (
          <>
            <h5>New Medical details</h5>

            <MedicalForm
              form={form}
              onChange={onChange}
              error={error}
              effectiveDateFlag={effectiveDateFlag}
            />

            <FormBtn
              id={id}
              backBtnTitle={"Cancel"}
              onSubmit={onSubmit}
              backOnClick={() => setIsActive(false)}
            />
          </>
        ) : (
          <div className={"mt-4 text-center"}>
            <Button onClick={history.goBack} variant="secondary" className="mr-2">
              {"Back"}
            </Button>

            <Button onClick={() => setIsActive(true)} variant="primary" className="ml-2">
              {"Change Medical SME"}
            </Button>
          </div>
        )}

        <MedicalHistoryList
          data={historyList}
          getFormData={getFormData}
          siteList={siteList}
        />
      </Card.Body>
    </Card>
  );
}

export default ContractorPersonMedicalForm;
